import Resource from '@/plugins/sdk/Resource'
import { STRING, UUID, DATETIME, BOOLEAN, ITEM } from '@/plugins/sdk/fields'

export default class extends Resource {
  static name = 'account_event_type'

  static get fields () {
    return {
      id: new UUID(),
      name: new STRING(),
      description: new STRING(),
      next_event_required: new BOOLEAN(),
      next_event_type: new ITEM(this),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME()
    }
  }
}
